import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgBusiness = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M5.5 3.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v1h-5v-1Z"
      stroke="currentColor"
    />
    <rect
      x={0.5}
      y={4.5}
      width={15}
      height={9}
      rx={2}
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path d="M.5 7.5h15M7 9.5h2" stroke="currentColor" strokeLinecap="round" />
  </svg>
);
const ForwardRef = forwardRef(SvgBusiness);
export default ForwardRef;
